export const QUESTION_TYPE_SURVEY = 'event_survey';
export const QUESTION_TYPE_AAQ = 'ask_a_question';
export const QUESTION_TYPE_LIVE_POLL = 'live_poll';

export const DATE_TIME_FORMAT = 'MM/DD/YYYY LT';

export const POLLING_FREQUENCY = 3000;
